import { notificationUtils } from 'features/notifications'
import { LoadingButton, StackIcon } from 'shared/ui'

import { api, connectorApi } from '../../api'

export interface AddToSystemProps {
	className?: string
	entityId?: string
}

export function AddToSystem({ className, entityId }: AddToSystemProps) {
	const [fetchContact, optionGet] =
		connectorApi.useLazyGetLinkedInContactQuery()
	const [save, optionSave] = api.useSaveContactMutation()
	async function handleClick() {
		const { data } = await fetchContact(entityId!)

		if (data) {
			await save(data)
			notificationUtils.snackById('n3.35')
		}
	}

	return (
		<LoadingButton
			className={className}
			disabled={!entityId}
			isLoading={optionGet.isLoading || optionSave.isLoading}
			onClick={handleClick}
		>
			<StackIcon icon='plus' />
			Add to Snaily
		</LoadingButton>
	)
}
